import { Helmet } from 'react-helmet-async'
import styled from 'styled-components'

import PerformanceDetail from '~/features/special-performance/components/PerformanceDetail'
import theme from '~/shared/styles/theme'

function SpecialPerformancePage() {
  return (
    <Wrapper>
      <Helmet>
        <title>SEOUL INDIE IDOL FESTIVAL 공연 예매</title>
        <meta
          name="description"
          content="📢서울 인디 아이돌 페스티벌 2024 Spring
                      「제4회 일러스타 페스」의 메인 무대에서
                      한국 인디 아이돌들의 대제전
                      「서울 인디 아이돌 페스티벌 2024 Spring」 개최!🎉"
        />
        <meta
          name="keywords"
          content="서울 인디 아이돌 페스티벌, 일러스타 페스, 서울 인디 아이돌 페스티벌 2024 Spring, 서울 인디 아이돌 페스티벌 2024 Spring 공연 예매, SIF, SEOUL INDIE IDOL FESTIVAL, 일러스타페스, ILLUSTARFES"
        />
        <meta
          property="og:image"
          content="https://static.illustar.net/temp/special-performance.webp"
        />
        <meta
          property="og:url"
          content={`${import.meta.env.VITE_REDIRECT_URI}/sif-rainbowstage1`}
        />
      </Helmet>
      <PerformanceDetail />
    </Wrapper>
  )
}

export default SpecialPerformancePage

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;

  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: 100px;

  @media ${theme.device.medium} {
    gap: 40px;
    width: 90vw;
    margin-top: 100px;
  }
`
